"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _classes = _interopRequireDefault(require("@nerdwallet/base-styles/classes"));

var _loadingWalletModule = _interopRequireDefault(require("./loading-wallet.module.less"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var LoadingWallet = function LoadingWallet(_ref) {
  var className = _ref.className;
  return _react["default"].createElement("div", null, _react["default"].createElement("span", {
    className: (0, _classes["default"])('screen-reader-only')
  }, "Loading..."), _react["default"].createElement("div", {
    className: (0, _classnames["default"])(_loadingWalletModule["default"].wallet, className),
    "aria-hidden": "true"
  }, _react["default"].createElement("svg", {
    className: (0, _classes["default"])('display-none')
  }, _react["default"].createElement("symbol", {
    id: "nw-wallet-card",
    viewBox: "0 0 38 56"
  }, _react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFF",
    d: "M5 54.5c-1.9 0-3.5-1.6-3.5-3.5V5c0-1.9 1.6-3.5 3.5-3.5h28c1.9 0 3.5 1.6 3.5 3.5v46c0 1.9-1.6 3.5-3.5 3.5H5z"
  }), _react["default"].createElement("path", {
    fill: "inherit",
    d: "M33 3c1.1 0 2 .9 2 2v46c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h28m0-3H5C2.2 0 0 2.2 0 5v46c0 2.8 2.2 5 5 5h28c2.8 0 5-2.2 5-5V5c0-2.8-2.2-5-5-5z"
  }), _react["default"].createElement("g", null, _react["default"].createElement("path", {
    fill: "inherit",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 3h6v50H9z"
  })))), _react["default"].createElement("div", {
    className: _loadingWalletModule["default"].back
  }, _react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 49"
  }, _react["default"].createElement("path", {
    d: "M75 4c0-2.2-1.8-4-4-4L8 3c-.7 0-1.3 0-1.9.1C2.4 3.7 0 6.1 0 10v39h3V11c0-2.8 1.2-4.4 3.4-4.8.5-.1 1-.2 1.6-.2l62-3c1.1 0 2 .9 2 2v9h3V4z"
  }))), _react["default"].createElement("div", {
    className: _loadingWalletModule["default"].license
  }, _react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38 56"
  }, _react["default"].createElement("use", {
    xlinkHref: "#nw-wallet-card"
  }))), _react["default"].createElement("div", {
    className: _loadingWalletModule["default"]['credit-card']
  }, _react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38 56"
  }, _react["default"].createElement("use", {
    xlinkHref: "#nw-wallet-card"
  }))), _react["default"].createElement("div", {
    className: _loadingWalletModule["default"].money
  }, _react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38 56"
  }, _react["default"].createElement("use", {
    xlinkHref: "#nw-wallet-card"
  }))), _react["default"].createElement("div", {
    className: _loadingWalletModule["default"].front
  }, _react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 85 62"
  }, _react["default"].createElement("path", {
    fill: "#FFF",
    d: "M82 2H20V0H5C3.9 0 3 .9 3 2L2 58c0 1.1.9 2 2 2h78c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"
  }), _react["default"].createElement("path", {
    fill: "#000",
    d: "M81 0H13c-.7 0-2 .1-2 1.5S12.3 3 13 3h67c1.1 0 2 .9 2 2v52c0 1.1-.9 2-2 2H5c-1.2 0-2-.7-2-2V5H0v53c0 2.7 1.4 4 4 4h77c2.2 0 4-1.8 4-4V4c0-2.2-1.8-4-4-4z"
  }), _react["default"].createElement("path", {
    fill: "#000",
    d: "M77.5 16c-.8 0-1.5.7-1.5 1.5v5c0 .8.7 1.5 1.5 1.5s1.5-.7 1.5-1.5v-5c0-.8-.7-1.5-1.5-1.5zm0 11c-.8 0-1.5.7-1.5 1.5v5c0 .8.7 1.5 1.5 1.5s1.5-.7 1.5-1.5v-5c0-.8-.7-1.5-1.5-1.5zm0 11c-.8 0-1.5.7-1.5 1.5v5c0 .8.7 1.5 1.5 1.5s1.5-.7 1.5-1.5v-5c0-.8-.7-1.5-1.5-1.5zm0 11c-.8 0-1.5.7-1.5 1.5V53h-2.6c-.8 0-1.4.7-1.4 1.5s.6 1.5 1.4 1.5H76c1.7 0 3-1.4 3-2.9v-2.6c0-.8-.7-1.5-1.5-1.5zM76.1 6h-2.6c-.8 0-1.5.7-1.5 1.5S72.7 9 73.5 9H76v2.6c0 .8.7 1.4 1.5 1.4s1.5-.6 1.5-1.4V9c0-1.7-1.4-3-2.9-3zM12.5 53h-5c-.8 0-1.5.7-1.5 1.5S6.7 56 7.5 56h5c.8 0 1.5-.7 1.5-1.5s-.7-1.5-1.5-1.5zm11 0h-5c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h5c.8 0 1.5-.7 1.5-1.5s-.7-1.5-1.5-1.5zm11 0h-5c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h5c.8 0 1.5-.7 1.5-1.5s-.7-1.5-1.5-1.5zm11 0h-5c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h5c.8 0 1.5-.7 1.5-1.5s-.7-1.5-1.5-1.5zm11 0h-5c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h5c.8 0 1.5-.7 1.5-1.5s-.7-1.5-1.5-1.5zm11 0h-5c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h5c.8 0 1.5-.7 1.5-1.5s-.7-1.5-1.5-1.5zm0-47h-5c-.8 0-1.5.7-1.5 1.5S61.7 9 62.5 9h5c.8 0 1.5-.7 1.5-1.5S68.3 6 67.5 6zm-11 0h-5c-.8 0-1.5.7-1.5 1.5S50.7 9 51.5 9h5c.8 0 1.5-.7 1.5-1.5S57.3 6 56.5 6zm-11 0h-5c-.8 0-1.5.7-1.5 1.5S39.7 9 40.5 9h5c.8 0 1.5-.7 1.5-1.5S46.3 6 45.5 6zm-11 0h-5c-.8 0-1.5.7-1.5 1.5S28.7 9 29.5 9h5c.8 0 1.5-.7 1.5-1.5S35.3 6 34.5 6zm-11 0h-5c-.8 0-1.5.7-1.5 1.5S17.7 9 18.5 9h5c.8 0 1.5-.7 1.5-1.5S24.3 6 23.5 6z"
  })))));
};

LoadingWallet.propTypes = {
  className: _propTypes["default"].string
};
LoadingWallet.defaultProps = {
  className: null
};
var _default = LoadingWallet;
exports["default"] = _default;